<template>
  <!-- LIST ITEM IN SIDEBAR -->
  <li
    :key="bookshelf.id"
    :class="{
      'active': getCurrentBookshelf && getCurrentBookshelf.id == bookshelf.id
    }"
  >
    <button
      class="snb_list"
      @click="navigateBookshelf(bookshelf.id), $emit('closeMobileMenu')"
    >
      <span class="shelf_list">
        <b :class="{ 'non_visible': bookshelf.bookshelfTp === 'DBS' }">▶</b>
        <span class="bookshelf_name">{{ bookshelf.name }}</span>
        <span class="num_style">({{ num }})</span>
      </span>
    </button>
    <span></span>
    <div
      v-if="!bookshelf.isDefault && bookshelf.bookshelfTp === 'UBS'"
      class="select_area"
    >
      <div
        v-if="!isShelfMoveMode"
        class="select_item"
        :class="{ active: showEditMenu }"
      >
        <button
          v-on-clickaway="closeEditMenu"
          type="button"
          class="select_option btn_snb_modify"
          @click="toggleEditMenu"
        >
          {{ $t('library.listitem.edit') }}
        </button>
        <!-- DROPDOWN MENU -->
        <ul class="select_list">
          <li>
            <button
              type="button"
              class="list_option"
              @click.stop="toggleEditMenu"
              @click="$emit('openEditModal')"
            >
              <span>수정</span>
            </button>
          </li>
          <li>
            <button
              type="button"
              class="list_option"
              @click="$emit('openDeleteModal')"
            >
              <span>삭제</span>
            </button>
          </li>
        </ul>
      </div>
      <div
        v-else
        :class="{ non_visible: bookshelf.bookshelfTp === 'DBS' }"
        class="move_shelf"
      >
        <span></span>
        <span></span>
      </div>
    </div>
    <div v-else class="shelf_move_controls">
      <span
        v-if="getBookshelves.length > 2 && !isShelfMoveMode"
        class="book_step"
        @click.stop="handleMoveShelf"
      >
        ↕ 책장 순서
      </span>
      <span
        v-if="isShelfMoveMode"
        class="fix_shelf"
        @click.stop="handleFixShelf"
      >
        완료
      </span>
    </div>
  </li>
</template>

<script>
import { mapGetters } from 'vuex'

import {
  BOOKSHELF_SET_CURRENT,
  BOOKSHELF_BOOK_COUNT,
  UI_UNSELECT_ALL_BOOKS,
  UI_DISABLE_MOVE_BOOK_MODE
} from '@/store/types'

export default {
  name: 'ListItem',
  props: {
    bookshelf: {
      type: Object,
      required: true
    },
    isShelfMoveMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showEditMenu: false,
      num: 0,
      modeInit: false
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentBookshelf',
      'getBookshelfTotalBookCount',
      'isMoveBookModeEnabled',
      'getBookshelves'
    ])
  },
  watch: {
    isMoveBookModeEnabled(newValue) {
      this.modeInit = newValue
    }
  },
  created() {
    this.$root.$on('bookshelf-counts-updated', this.updateBookCount)
  },
  beforeDestroy() {
    this.$root.$off('bookshelf-counts-updated', this.updateBookCount)
  },
  async beforeMount() {
    this.num = await this.$store.dispatch(BOOKSHELF_BOOK_COUNT, {
      bookshelfId: this.bookshelf.id || ''
    })
  },
  methods: {
    handleMoveShelf() {
      this.$emit('moveShelf')
    },
    handleFixShelf() {
      this.$emit('fixShelf')
    },
    async updateBookCount() {
      this.num = await this.$store.dispatch(BOOKSHELF_BOOK_COUNT, {
        bookshelfId: this.bookshelf.id || ''
      })
    },
    navigateBookshelf() {
      const id = this.bookshelf.id
      if (!this.getCurrentBookshelf) {
        this.$store.commit(BOOKSHELF_SET_CURRENT, id)
        this.$root.$emit('default-books')
      }
      if (this.getCurrentBookshelf.id !== id) {
        this.$store.commit(BOOKSHELF_SET_CURRENT, id)
        this.$root.$emit('default-books')
        if (this.isMoveBookModeEnabled == true) {
          this.$store.commit(UI_UNSELECT_ALL_BOOKS)
          this.$store.commit(UI_DISABLE_MOVE_BOOK_MODE)
        }
        this.$emit('bookshelfChanged')
      }

      this.$router.push({ name: 'library', params: { id } }).catch(() => {})
      this.$emit('closeMobileMenu')
    },
    toggleEditMenu() {
      this.showEditMenu = !this.showEditMenu
    },
    closeEditMenu() {
      this.showEditMenu = false
    }
  }
}
</script>

<style lang="scss" scoped>
.snb_sub {
  li {
    &.active {
      .num_style {
        color: #ffffff;
      }
    }
  }
}
.snb_list {
  text-align: left;
}

.snb_list span b {
  font-size: 5px;
  vertical-align: top;
  margin-right: 8px;
  &.non_visible {
    visibility: hidden;
  }
}
// 새로 추가: 책장 이동 컨트롤 스타일
.shelf_move_controls {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 9px;
  z-index: 10;
  width: 90px;
  background: #fff;
  border-radius: 22px;
  cursor: pointer;
  &.always-visible {
    display: block;
  }
  span {
    display: block;
    text-align: center;
    padding: 5px 10px;
    border-radius: 22px;
  }
}
.book_step {
  border: 1px solid #d9d9d9;
}
.fix_shelf {
  padding: 4px 14px;
  user-select: none;
  cursor: pointer;
  background: #000;
  color: #fff;
  border-radius: 22px;
  border: none;
}
.shelf_list {
  display: flex;
}
.bookshelf_name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.num_style {
  color: #595959;
}
.move_shelf {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  cursor: pointer;
  &.non_visible {
    visibility: hidden;
  }
  span {
    width: 90%;
    height: 1px;
    background-color: #999999;
    &:first-child {
      margin-bottom: 10px;
    }
  }
}
.aside_snb .snb_box .snb_sub > li.active .move_shelf {
  span {
    background-color: #fff;
  }
}
</style>
